module.exports = __webpack_public_path__ + "img/103-social-feed-colour.f5c07640.svg";